// extracted by extract-css-chunks-webpack-plugin
module.exports = {"fulfilmentLabel":"fulfilmentLabel_VrGtO"};